/**
 * Episode Presentational Component
 * View: Displays an episode
 */

require('../styles/photos.scss');

import React from 'react';
import Sharing from './Sharing';

import Bigbox from './Bigbox';

const Photos = ({photos, onPhotoClick}) => {
    if(photos){
      return (
          <div className="photos-container">
            <div className="photos" id="photos">
              <h2 className="photos__title">Photos</h2>

              <Sharing
                classes="photos__sharing"
                hash="photos"
                url={function(){ return location.href.split('score=')[0].replace('&', '').replace('?', '') }()} />

              <ul className="photos-list">
                {
                  photos.map((photo, key) => {
                    var photoClasses = '';
                    if(photo.original.indexOf('.pano.') >= 0){
                      photoClasses += 'pano';
                    }
                    return (
                      <li key={key} className={'photo ' + photoClasses} onClick={ onPhotoClick.bind(this, key) }>
                        <figure>
                          <img src={ photo.thumbnail } srcSet={ (function(){
                            return photo.thumbnail.replace('thumbnail.jpg','thumbnail-2x.jpg') + ' 2000w'
                          })() } alt="" />
                          <figcaption>
                            <span className="photo__title">{photo.title}</span>
                            <span className="photo__legend">{photo.description}</span>
                          </figcaption>
                        </figure>
                      </li>
                    );
                  })
                }
              </ul>
            </div>
            <Bigbox />
          </div>
      )
  }else{
    return null;
  }
}

Photos.propTypes = {
  photos: React.PropTypes.arrayOf(React.PropTypes.object).isRequired,
  onPhotoClick: React.PropTypes.func
};

Photos.defaultProps = {
  photos: [],
  onPhotoClick: function(){}
};


export default Photos;



// WEBPACK FOOTER //
// ./src/components/Photos.js